import { fetchApi } from '@/services/api-client';

export type SstPatternFlag =
  | 'late-pattern'
  | 'attendance-low'
  | 'class-attendance-low'
  | 'incident-cluster'
  | 'recognition-low'
  | 'grades-low'
  | 'grades-dropping';

export interface SstPatternDay {
  date: string;
  status: 'present' | 'late' | 'absent' | 'excused' | 'suspended' | null;
  minutesLate: number | null;
  incidents: number;
  mssDay: boolean;
}

export interface SstPatternRow {
  studentId: string;
  fullName: string;
  nickname: string | null;
  photoUrl: string;
  gradeLevel: number | null;
  supervisedSince: string | null;
  days: SstPatternDay[];
  lateness: {
    count: number;
    averageMinutes: number | null;
    minutesLost: number;
    byWeekday: number[];
    unmeasured: number;
  } | null;
  attendance: {
    /** Null when the child has no attendance record at all — never fabricated as 100%. */
    rate: number | null;
    recordedDays: number;
    reasons: Record<string, number>;
    longestBlock: number;
    gradeAverage: number | null;
  };
  classes: { classId: string; className: string; rate: number; classAverage: number | null; periods: number }[];
  incidents: {
    total: number;
    spanDays: number;
    byRole: Record<string, number>;
    repeatedType: string | null;
    items: { id: string; date: string; type: string; role: string }[];
  } | null;
  recognition: { lastFive: number; lastThirty: number; gradeAveragePerDay: number } | null;
  /** The child's latest report card this year, drafts included, against the one before it. */
  grades: {
    periodName: string;
    previousPeriodName: string | null;
    low: boolean;
    dropping: boolean;
    lowMarks: { subject: string; label: string; title: string }[];
    drops: { subject: string; from: string; to: string }[];
  } | null;
  flags: SstPatternFlag[];
}

export interface SstPatternsResponse {
  windowFrom: string;
  windowTo: string;
  schoolDays: number;
  /** The school's own "late after" time, so the page can say what a late arrival is measured
   *  against rather than leaving the reader to guess. */
  cutoffHhMm: string;
  summary: { withAnyFlag: number; supervised: number; byFlag: Record<SstPatternFlag, number> };
  students: SstPatternRow[];
}

export const sstPatternsApi = {
  list: () => fetchApi<SstPatternsResponse>('/admin/sst/patterns'),
};
